
import { supabase } from "@/integrations/supabase/client";
import { logger } from "@/lib/logger";
import { BaseApiClient } from "../../baseApiClient";

/**
 * Terminate a staff member (sets is_active to false)
 */
export const terminateStaff = async (businessId: string, staffId: string): Promise<boolean> => {
  try {
    logger.info({
      message: "Terminating staff",
      context: { businessId, staffId }
    });
    
    if (!businessId || !staffId) {
      logger.error({
        message: "Error terminating staff",
        context: { businessId, staffId }
      });
      throw new Error("Both businessId and staffId are required to terminate staff");
    }
    
    // Call the Supabase edge function that handles staff termination
    const { data, error } = await supabase.functions.invoke('ai-staff-management', {
      body: { 
        action: 'terminate',
        businessId,
        staffId
      }
    });
    
    if (error) {
      throw new Error(`Failed to terminate staff: ${error.message}`);
    }
    
    // Clear related caches
    BaseApiClient.clearCache(`staff:${businessId}:${staffId}`);
    BaseApiClient.clearCache(`staff:all:${businessId}`);
    
    return data?.success || false;
  } catch (error) {
    logger.error({
      message: "Error terminating staff",
      error: error instanceof Error ? error : new Error(String(error)),
      context: { businessId, staffId }
    });
    throw error;
  }
};
